export default __webpack_public_path__ + "static/authentic-de8fde582957cfb80284ece49cb2247f.svg";